import { useToastDispatch } from 'contexts/toasts/toast-context'

export default function useShowError() {
	const dispatch = useToastDispatch()

	return ( id: string, message: string ) => {
		dispatch( {
			type: 'addToast',
			payload: {
				id: `${id}-${Date.now()}-error`,
				title: message,
				color: 'danger',
			}
		} )
	}
}
